import React from 'react'

class SelectMenuClass extends React.Component {
    render(){
        const options = this.props.list.map((option, index) => {
            return (
            <option key = {index} value={option.value}>{option.label}</option>
            )
        })
        
        // return (
        //     <select style={{color: '#000'}} {...this.props}>
        //         {options}
        //     </select>
        // )

        const { forwardedRef, ...rest } = this.props;

        return (
            <select
                ref={forwardedRef}
                style={{ color: '#000' }}
                {...rest}
            >
                {options}
            </select>
        );        

    }

}

const SelectMenu = React.forwardRef((props, ref) => {
    return <SelectMenuClass {...props} forwardedRef={ref} />;
});

export default SelectMenu